/**
 * @prettier
 * @flow
 */
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import React from 'react';
import { translate } from 'src/utils/translate/translate';

export function CancelButton({ tooltip, onClick }: Props) {
    return (
        <>
            <Tooltip title={tooltip || translate('Cancel')}>
                <IconButton onClick={onClick}>
                    <ClearIcon />
                </IconButton>
            </Tooltip>
        </>
    );
}

type Props = {
    tooltip?: string,
    onClick?: Function,
};
